<h1 mat-dialog-title>{{ isEditing ? 'Edit' : 'Add' }} Bulk Pricing Model</h1>

<div mat-dialog-content class="dialog-content">
  <form [formGroup]="form" class="model-form">
    <div class="form-row">
      <mat-form-field appearance="outline" class="grow">
        <mat-label>Product tag</mat-label>
        <input matInput formControlName="tag" placeholder="igsmodel">
        <mat-hint>Products with this tag get these discounts</mat-hint>
        <mat-error *ngIf="form.get('tag')?.hasError('required')">A tag is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="grow">
        <mat-label>Display name</mat-label>
        <input matInput formControlName="label" placeholder="IGS Model">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="narrow">
        <mat-label>Priority</mat-label>
        <input matInput type="number" formControlName="priority">
        <mat-hint>Highest wins on a tie</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="grow">
        <mat-label>Stores</mat-label>
        <mat-select formControlName="stores" multiple>
          <mat-option *ngFor="let store of storeOptions" [value]="store.value">{{ store.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-slide-toggle formControlName="active" class="active-toggle">Active</mat-slide-toggle>
    </div>

    <p class="form-note">If a product carries the tags of two models, the one with the highest priority wins.</p>

    <div class="tiers-section">
      <div class="tiers-header">
        <h3>Discount tiers</h3>
        <span class="tiers-hint">Leave the top tier's "up to" blank for no ceiling</span>
      </div>

      <div formArrayName="tiers">
        <div class="tier-row" *ngFor="let tier of tiers.controls; let i = index" [formGroupName]="i">
          <mat-form-field appearance="outline">
            <mat-label>From ($)</mat-label>
            <input matInput type="number" formControlName="min_amount">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Up to ($)</mat-label>
            <input matInput type="number" formControlName="max_amount" placeholder="no ceiling">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Discount (%)</mat-label>
            <input matInput type="number" formControlName="discount_percent">
          </mat-form-field>

          <button mat-icon-button type="button" (click)="removeTier(i)" matTooltip="Remove tier">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>

      <button mat-button type="button" (click)="addTier()">
        <mat-icon>add</mat-icon>
        Add tier
      </button>
    </div>

    <div class="preview">
      <div class="preview-title">Check a price</div>
      <div class="preview-row">
        <mat-form-field appearance="outline">
          <mat-label>Item price ($)</mat-label>
          <input matInput type="number" [(ngModel)]="previewPrice" [ngModelOptions]="{standalone: true}">
        </mat-form-field>

        <div class="preview-result">
          <span *ngIf="previewDiscount() > 0">
            Goes out at <strong>${{ previewFeedPrice() }}</strong> ({{ previewDiscount() }}% off)
          </span>
          <span *ngIf="previewDiscount() === 0" class="preview-none">
            Reaches no tier on its own &mdash; stays at <strong>${{ previewPrice }}</strong>
          </span>
        </div>
      </div>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Note</mat-label>
      <textarea matInput formControlName="note" rows="2"></textarea>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="cancel()" [disabled]="saving">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid || saving">
    <mat-spinner diameter="20" *ngIf="saving"></mat-spinner>
    <span *ngIf="!saving">{{ isEditing ? 'Update' : 'Create' }}</span>
  </button>
</div>
